import { App, ConfigProvider } from 'antd'
import ru_RU from 'antd/es/locale/ru_RU'

import { PropsWithChildren } from 'react'

import { palette } from 'shared/config/styles/palette'

import { useTheme } from '../../libs/useTheme'

import './styles.css'

export function AntProvider({ children }: PropsWithChildren) {
  const { currentTheme } = useTheme()
  return (
    <ConfigProvider
      theme={{
        token: {
          borderRadius: 8,
        },
        components: {
          Button: {},
          Form: {
            marginLG: 8,
          },
          Table: {
            headerBorderRadius: 3,
          },
          Input: {
            colorBorder: palette.primary,
            colorTextPlaceholder: palette.light_gray_4,
          },
          Menu: {},
          Segmented: {
            trackPadding: 3,
            controlHeight: 32,
            controlHeightLG: 22,
            controlPaddingHorizontal: 32,
            itemSelectedColor: 'rgb(0,146,161)',
            colorText: 'rgb(0,146,161)',
            trackBg: 'rgb(236,240,240)',
            borderRadius: 10,
            borderRadiusLG: 10,
            borderRadiusSM: 10,
            motionDurationMid: '0.4s',
          },
        },
      }}
      locale={ru_RU}
    >
      <App className={`${currentTheme} h-full w-full`}>{children}</App>
    </ConfigProvider>
  )
}
